import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';
import { filterActiveSafari } from '../utils/photoUtils';

export const getSafariDetail = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const response = await api('get', `safari/${data.slug}`);
        return filterActiveSafari(response.data) || [];
    });

